/**
 * Pristrappor (volymrabatt) — uppdaterar tier-tabellen på single-product-sidan
 * vid variantbyte. För variabla produkter renderas tabellen via det HTML-blob
 * som temat injicerar i varje variations data (woocommerce_available_variation).
 *
 * För enkla produkter renderas tabellen direkt server-side — inget JS behövs här.
 * Häckkalkylatorn (hedge-calculator.js) hanterar sina egna pris-displays.
 */
(function ($) {
    'use strict';

    if (typeof $ === 'undefined') return;

    function setTableHtml(html) {
        $('[data-lw-pricing-tiers-target]').html(html || '');
    }

    // Variabla produkter har form.variations_form; enkla har bara form.cart.
    const hasVariationsForm = !!document.querySelector('form.variations_form');

    // currentTiers fylls från found_variation (variabla) eller data-lw-tiers (enkla).
    let currentTiers = [];
    let basePriceHtml = '';

    function findActiveTier(qty) {
        for (const t of currentTiers) {
            const max = t.max > 0 ? t.max : Infinity;
            if (qty >= t.min && qty <= max) return t;
        }
        return null;
    }

    // Variantpriset är upplyft till en egen container ovanför variantväljaren
    // (lw_single_product_variation_price.php); WC:s original döljs med CSS.
    // Fallback till WC:s nod för produkter som saknar den upplyfta containern
    // (t.ex. häckkalkylator-produkter).
    function variationPriceSelector() {
        return document.querySelector('[data-lw-variation-price]')
            ? '[data-lw-variation-price] .price'
            : '.woocommerce-variation-price .price';
    }

    function getQty() {
        const input = document.querySelector('form.cart input[name="quantity"]');
        const val = input ? parseInt(input.value, 10) : 1;
        return Number.isFinite(val) && val > 0 ? val : 1;
    }

    function updatePriceFor(selector, qty) {
        const $price = $(selector).first();
        if (!$price.length) return;
        const tier = findActiveTier(qty);
        if (tier && tier.price_html) {
            $price.html(tier.price_html);
        } else if (basePriceHtml) {
            $price.html(basePriceHtml);
        }
    }

    // --- Variabla produkter ---
    $(document).on('found_variation', 'form.variations_form', function (e, variation) {
        if (!variation) return;
        currentTiers = Array.isArray(variation.pricing_tiers) ? variation.pricing_tiers : [];
        basePriceHtml = variation.price_html || '';
        setTableHtml(variation.pricing_tiers_table_html || '');
        // Defer så WC:s egen handler hinner sätta sitt pris först — vi kör efter.
        if (currentTiers.length) {
            setTimeout(() => updatePriceFor(variationPriceSelector(), getQty()), 0);
        }
    });

    $(document).on('reset_data hide_variation', 'form.variations_form', function () {
        currentTiers = [];
        basePriceHtml = '';
        setTableHtml('');
    });

    // --- Enkla produkter: init från data-lw-tiers ---
    if (!hasVariationsForm) {
        const $simpleContainer = $('.lw-pricing-tiers-price').first();
        const raw = $simpleContainer.attr('data-lw-tiers');
        if (raw) {
            try {
                const parsed = JSON.parse(raw);
                if (Array.isArray(parsed) && parsed.length) {
                    currentTiers = parsed;
                    basePriceHtml = $simpleContainer.find('.price').first().html() || '';
                    // Initial render om sidan laddas med qty inom en tier.
                    updatePriceFor('.lw-pricing-tiers-price .price', getQty());
                }
            } catch (err) {
                // ignore parse errors
            }
        }
    }

    // --- Kvantitetsändring: dirigera till rätt prismål ---
    $(document).on('input change', 'form.cart input[name="quantity"]', function () {
        if (!currentTiers.length) return;
        const qty = parseInt(this.value, 10) || 1;
        if (hasVariationsForm) {
            updatePriceFor(variationPriceSelector(), qty);
        } else {
            updatePriceFor('.lw-pricing-tiers-price .price', qty);
        }
    });
})(window.jQuery);
